<div class="collection-wrapper content-wrapper">
  <mat-card>
    <mat-card-content>
      <div class=" head-container">
        <h1>{{'collections.heading' | translate}}</h1>
        <!-- <div (mouseover)="onTraningIcon(videoAssetGroups.CollectionManagement)">
          <img class="trainingIcon" src="../../../assets/favicon/video.png">
        </div>
        <div class="popupHover">
          <ng-container *ngIf="isHidden">
            <div class="hideshow">
              <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
            </div>
          </ng-container>
        </div> -->
      </div>
      <div class="itemBtn">
        <span class="spacer"></span>
        <div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-warn" aria-label="Add New Collection"
              [disabled]="(roleSer.accessData && (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true))"
              (click)="openNewCollectionDialog()"> + {{'collections.btnAddColl' | translate}}</button>
          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper">
            <input type="text" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model=""
              placeholder="{{'collections.inputColl' | translate}}" #input [(ngModel)]="searchValue" filterValidator="Name">
          </div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-primary" aria-label="Search" (click)="applyFilter(input.value)">{{'collections.btnSearch' | translate}}</button>
            <button mat-flat-button color="" class="btn-flat" aria-label="Reset" (click)='resetFilter()'>{{'collections.btnReset' | translate}}</button>
          </div>
        </div>
      </div>
      <div *ngIf="isNoCollections" class="data-not-found-container table-container">
        <span>{{'collections.noCollectionMsg' | translate}}</span>
      </div>
      <div *ngIf="!isNoCollections && !isFilterData">
        <div class="table-container">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="collectionName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"> {{'collections.column1' | translate}} </th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="row?.collectionName?.length > 40 then sliceTitle else noSlice">
                </ng-container>
                <ng-template #sliceTitle>
                  <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.collectionName}}" matTooltipPosition="above">
                    {{row?.collectionName | slice: 0:40}}...</div>
                </ng-template>
                <ng-template #noSlice>
                  <div class="text-bold">{{row?.collectionName }}</div>
                </ng-template>

                <ng-container *ngIf="row?.description?.length > 40 then sliceDescription else nosliceDescription">
                </ng-container>
                <ng-template #sliceDescription>
                  <div class="description-text" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.description}}" matTooltipPosition="above">
                    {{row?.description | slice: 0 :40}}...
                  </div>
                </ng-template>
                <ng-template #nosliceDescription>
                  <div class="description-text"> {{row?.description }} </div>
                </ng-template>

              </td>
            </ng-container>

            <ng-container matColumnDef="language">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"> {{'collections.column2' | translate}} </th>
              <td mat-cell *matCellDef="let row">
                {{row?.language}}
              </td>
            </ng-container>

            <ng-container matColumnDef="timezone">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'collections.column3' | translate}}</th>
              <td mat-cell *matCellDef="let row"> {{row?.timezone}} </td>
            </ng-container>


            <ng-container matColumnDef="modifiedDate">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"> {{'collections.column4' | translate}} </th>
              <td mat-cell *matCellDef="let row">
                <div class="text-bold"> {{row?.modifiedBy}} </div>
                <div> {{row?.modifiedDateTime | dateAgo}} </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns;" (click)="collectioDetails(row)"></tr>


          </table>
        </div>
        <div class="collection-paginator">
          <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
      <div class="data-not-found-container" *ngIf="isFilterData">
        <p>{{'collections.errorMsg' | translate}}</p>
      </div>

    </mat-card-content>
  </mat-card>
</div>
